import React from "react"
import ReactDOM from "react-dom/client"
import { BrowserRouter as Router, Route, Routes } from "react-router-dom"
import Accueil from "./views/Accueil/Accueil"
import Bio from "./views/Bio/Bio"
import Contact from "./views/Contact/Contact"
import ProjectPage from "./views/ProjectPage/ProjectPage"
import Header from "./components/Header/Header.jsx"
import Footer from "./components/Footer/Footer.jsx"
import Error from "./components/Error/Error.jsx"
import ScrollToTop from "./utils/hooks/ScrollToTop"
import { createGlobalStyle } from "styled-components"
import { LanguageProvider } from "./context/LanguageContext";
import "./index.css"
import "./assets/js/custom.js"

const GlobalStyle = createGlobalStyle`
    body{
        margin: 60px 40px 0;

        @media (max-width: 768px) {
            margin: 26px;
            margin-bottom: 0;
        }
    }

    #root {
        min-height: 90vh;
        font-family: "Inter", sans-serif;
        display: flex;
        flex-direction: column;
    }

    main {
        flex-grow: 1; /* Pousse le footer vers le bas */
    }
`

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
    <React.StrictMode>
        <Router>
            <GlobalStyle />
            <ScrollToTop />
            <LanguageProvider>
                <Header />
                <Routes>
                    <Route path="/" element={<Accueil />} />
                    <Route path="/:slug" element={<ProjectPage />} />
                    <Route path="/bio" element={<Bio />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="*" element={<Error />} />
                </Routes>
                <Footer />
            </LanguageProvider>
        </Router>
    </React.StrictMode>
)
